import Vue from 'vue';
import Router from 'vue-router';
import { userProfiles } from '../constants/profilesUsers';

// Containers
const TheContainer = () => import('@/containers/TheContainer');
const TheContainerClients = () => import('@/containers/TheContainerClients');

// Views
const Dashboard = () => import('@/views/Dashboard');

//usuarios internos de infoguia
//Rutas para el login y el logout
const Login = () => import('@/views/Login');
const Logout = () => import('@/views/Logout');

//Rutas para los componentes usados por las empresas
const Welcome = () => import('@/views/clients/welcome'); //bienvenida al cliente antes del formulario
const FormClient = () => import('@/views/clients/formclient'); //formulario multipasos
const thankYouMessage = () => import('@/views/clients/thankYouMessage'); //mensaje luego de llenar todo el formulario
const noUpdate = () => import('@/views/clients/noUpdate'); //vista para cuando el cliente no desea actualizar sus datos

//Rutas para el modulo usuarios
const NewUser = () => import('@/views/users/NewUser');
const AllUsers = () => import('@/views/users/AllUsers');
const EditUser = () => import('@/views/users/EditUser');

// Rutas para el modulo de envios masivos
const CreateMasiveRequest = () =>
	import('@/views/requests/createMasiveRequest');
const ConsultMasiveRequest = () => import('@/views/requests/consultRequests');
const RequestsAssigned = () => import('@/views/requests/requestsAssigned');
// Rutas para las solicitudes de envios individuales
const SingleRequest = () => import('@/views/requests/singleRequest');
const FormSingleRequest = () => import('@/views/requests/formSingleRequest');
// Rutas para las solicitudes masivas por procesar asignadas
const MassiveRequestForUser = () =>
	import('@/views/requests/massiveRequestForUser');
const RequestMassiveToProcess = () =>
	import('@/views/requests/detailMassiveRequestUser');
const FormMassiveRequest = () => import('@/views/requests/formMassiveRequest');
// Rutas para los reportes
const RequestsProcessed = () => import('@/views/reports/requestsProcessed');
const ReportSingleRequestSended = () =>
	import('@/views/reports/singleRequestsSended');
const RequestsByBussiness = () => import('@/views/reports/requestsByBussiness');
const ReportMassiveRequestsSended = () =>
	import('@/views/reports/MassiveRequestsSended');

Vue.use(Router);

const router = new Router({
	mode: 'history', // https://router.vuejs.org/api/#mode
	linkActiveClass: 'active',
	scrollBehavior: () => ({ y: 0 }),
	routes: configRoutes(),
});

function configRoutes() {
	return [
		{
			path: '/',
			redirect: {
				name: 'Login',
			},
		},
		//login
		{
			path: '/login',
			name: 'Login',
			component: Login,
		},
		//logout
		{
			path: '/logout',
			name: 'logout',
			component: Logout,
			meta: {
				requiresAuth: true,
			},
		},
		//rutas principales del sistema
		{
			path: '/',
			redirect: '/dashboard',
			name: 'Home',
			component: TheContainer,
			meta: {
				requiresAuth: true,
			},
			children: [
				//dashboard del sistema
				{
					path: 'dashboard',
					name: 'Dashboard',
					component: Dashboard,
				},
				//rutas para el modulo de usuarios
				{
					path: '/user',
					redirect: '/user/consult',
					meta: {
						label: 'Usuarios',
						onlyThisRoles: [
							userProfiles.adminUser,
							userProfiles.coordinator,
							userProfiles.superviser,
						],
					},
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: '/user/create',
							name: 'NewUser',
							meta: {
								label: 'Crear Nuevo Usuario',
								onlyThisRoles: [
									userProfiles.adminUser,
									userProfiles.coordinator,
									userProfiles.superviser,
								],
							},
							component: NewUser,
						},
						{
							path: '/user/consult',
							name: 'AllUsers',
							meta: {
								label: 'Consultar Usuarios',
								onlyThisRoles: [
									userProfiles.adminUser,
									userProfiles.coordinator,
									userProfiles.superviser,
								],
							},
							component: AllUsers,
						},
						{
							path: '/user/editUser/:userId',
							name: 'EditUser',
							props: true,
							meta: {
								label: 'Editar Usuario',
								onlyThisRoles: [
									userProfiles.adminUser,
									userProfiles.coordinator,
									userProfiles.superviser,
								],
							},
							component: EditUser,
						},
					],
				},
				//rutas para el modulo de envios masivos
				{
					path: '/masiverequests',
					redirect: '/masiverequests/createmasiverequest',
					meta: {
						label: 'Envíos Masivos',
						onlyThisRoles: [
							userProfiles.adminUser,
							userProfiles.coordinator,
							userProfiles.superviser,
						],
					},
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: '/masiverequests/createmasiverequest',
							name: 'MasiveRequest',
							meta: {
								label: 'Crear Envío Masivo',
								onlyThisRoles: [
									userProfiles.adminUser,
									userProfiles.coordinator,
									userProfiles.superviser,
								],
							},
							component: CreateMasiveRequest,
						},
						{
							path: '/masiverequests/consultmasiverequest',
							name: 'ConsultRequests',
							meta: {
								label: 'Envíos Masivos en Proceso',
								onlyThisRoles: [
									userProfiles.adminUser,
									userProfiles.coordinator,
									userProfiles.superviser,
								],
							},
							component: ConsultMasiveRequest,
						},
						{
							path: '/masiverequests/requestsAssigned',
							name: 'requestsAssigned',
							meta: {
								label: 'Solicitudes Asignadas',
								onlyThisRoles: [
									userProfiles.adminUser,
									userProfiles.coordinator,
									userProfiles.superviser,
								],
							},
							component: RequestsAssigned,
						},
					],
				},
				//rutas para solicitudes de envios individuales por usuarios
				{
					path: '/singlerequests',
					redirect: '/singlerequests/singleRequest',
					//name: 'singleRequest',
					meta: {
						label: 'Solicitudes Individuales',
					},
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: '/singlerequests/singleRequest',
							name: 'singleRequest',
							meta: {
								label: 'Solicitudes por Procesar',
							},
							component: SingleRequest,
						},
						{
							path:
								'/singlerequests/formSingleRequest/:requestId/:initialStep',
							name: 'formSingleRequest',
							props: true,
							meta: {
								label: 'Procesar Solicitud',
							},
							component: FormSingleRequest,
						},
					],
				},
				//rutas para solicitudes de envios masivos por usuario
				{
					path: '/massiverequestforuser',
					redirect: '/massiverequestforuser/massiveRequestForUser',
					//name: 'singleRequest',
					meta: {
						label: 'Solicitudes Masivas Asignadas',
					},
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path:
								'/massiverequestforuser/massiveRequestForUser',
							name: 'massiveRequestForUser',
							meta: {
								label: 'Solicitudes Asignadas',
							},
							component: MassiveRequestForUser,
						},
						{
							path:
								'/massiverequestforuser/detailMassiveRequestUser/:requestId',
							name: 'requestMassiveToProcess',
							props: true,
							meta: {
								label: 'Solicitudes por Procesar',
							},
							component: RequestMassiveToProcess,
						},
						{
							path:
								'/massiverequestforuser/formMassiveRequest/:requestId/:initialStep',
							name: 'formMassiveRequest',
							props: true,
							meta: {
								label: 'Procesar Solicitud',
							},
							component: FormMassiveRequest,
						},
					],
				},
				//rutas para los reportes
				{
					path: '/reports',
					redirect: '/reports/requestsProcessed',
					//name: 'singleRequest',
					meta: {
						label: 'Reportes',
					},
					component: {
						render(c) {
							return c('router-view');
						},
					},
					children: [
						{
							path: '/reports/requestsProcessed',
							name: 'requestsProcessed',
							meta: {
								label: 'Solicitudes Procesadas',
							},
							component: RequestsProcessed,
						},
						{
							path: '/reports/singleRequestsSended',
							name: 'reportSingleRequestSended',
							meta: {
								label: 'Envíos Individuales Realizados',
							},
							component: ReportSingleRequestSended,
						},
						{
							path: '/reports/MassiveRequestsSended',
							name: 'reportMassiveRequestsSended',
							meta: {
								label: 'Envíos Masivos Realizados',
							},
							component: ReportMassiveRequestsSended,
						},
						{
							path: '/reports/requestsByBussiness',
							name: 'requestsByBussiness',
							meta: {
								label: 'Solicitudes por Empresa',
							},
							component: RequestsByBussiness,
						},
					],
				},
			],
		},
		//rutas de las vistas de los clientes
		{
			path: '/clients',
			redirect: '/clients/welcome',
			name: 'Clients',
			component: TheContainerClients,
			children: [
				{
					path: 'welcome',
					name: 'Welcome',
					component: Welcome,
				},
				{
					path: 'formclient',
					name: 'FormClient',
					component: FormClient,
				},
				{
					path: 'thankYouMessage',
					name: 'thankYouMessage',
					component: thankYouMessage,
				},
				{
					path: 'noUpdate',
					name: 'noUpdate',
					component: noUpdate,
				},
			],
		},
	];
}

router.beforeEach((to, from, next) => {
	const publicPages = [
		'/login',
		'/clients/welcome',
		'/clients/formclient',
		'/clients/thankYouMessage',
		'/clients/noupdate',
	];
	const requireRole = to.matched.some((record) => record.meta.onlyThisRoles);
	const authRequired = !publicPages.includes(to.path);
	const loggedIn =
		sessionStorage.getItem('logged') !== null
			? sessionStorage.getItem('logged')
			: false;
	//const userType = sessionStorage.getItem('userType');
	let role =
		sessionStorage.getItem('userData') !== null
			? JSON.parse(sessionStorage.getItem('userData')).idprofiles
			: 0;
	if (authRequired && !loggedIn) {
		next({ name: 'Login' });
	} else {
		if (requireRole && !to.meta.onlyThisRoles.includes(role)) {
			next({ name: 'Dashboard' });
		}
		next();
	}
});

export default router;
